import { useViewerRoute } from '../contexts/ViewerRoute';

import useFileDownloadLink from './mutation/file/useFileDownloadLink';

interface Props {
  handleGetDownloadSuccess: (downloadUrl: string) => void;
}

const useGetFileDownloadLink = ({ handleGetDownloadSuccess }: Props) => {
  const { hashId, isBulk } = useViewerRoute();

  const { mutate } = useFileDownloadLink({
    onSuccess: async (data) => {
      await handleGetDownloadSuccess(data.data.data.url);
    },
  });

  const getDownloadLink = () => {
    if (hashId) {
      mutate({ hash: hashId as string, isBulk });
    }
  };

  return {
    getDownloadLink,
  };
};

export default useGetFileDownloadLink;
